import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas';

export const assistedInstallsParams = new SearchParams(screenSchema);

export const assistedInstallsLink = new Link(
  'assisted-installs',
  assistedInstallsParams
);
